var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.round) ? _c('ul', {
    class: (_vm.prefixCls + "-steps-round-con")
  }, [_vm._l((_vm.labels), function(label, index) {
    return [_c('li', {
      class: [_vm.getClassFromIndex(index)]
    }, [_c('div', {
      class: (_vm.prefixCls + "-steps-wrap")
    }, [_c('div', {
      class: (_vm.prefixCls + "-steps-round")
    }, [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('label', [_vm._v(_vm._s(label))])])]
  })], 2) : _c('div', {
    class: (_vm.prefixCls + "-steps clearfix")
  }, [_vm._l((_vm.labels), function(label, index) {
    return [_c('div', {
      class: (_vm.prefixCls + "-steps-wrap")
    }, [_c('div', {
      class: _vm.getClassFromIndex(index)
    }, [_c('label', [_c('span', {
      class: (_vm.prefixCls + "-steps-round")
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(label))])]), _vm._v(" "), (index < _vm.labels.length - 1) ? [_c('i', {
      class: (_vm.prefixCls + "-steps-triangle-right-bg")
    }), _vm._v(" "), _c('i', {
      class: (_vm.prefixCls + "-steps-triangle-right")
    })] : _vm._e()], 2)])]
  })], 2)
}
var staticRenderFns = []
render._withStripped = true
export default { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-7253445a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7253445a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Step/n3Step.vue
// module id = 642
// module chunks = 0 1